import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 12.4141L4.91406 19.5H11C11.5523 19.5 12 19.0523 12 18.5V12.4141ZM14 18.5C14 20.1569 12.6569 21.5 11 21.5H0.0859375L18.293 3.29297L18.4092 3.18262C19.6344 2.07542 21.5261 2.11216 22.707 3.29297L22.8174 3.40918C23.8892 4.59499 23.889 6.40493 22.8174 7.59082L22.707 7.70703L14 16.4141V18.5Z"}}]};

const SliceFilled = Vue.extend<IconProps>({
  name: 'SliceFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'slice-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SliceFilled;
